import { SearchParams } from '../searches/types'
import { EstimateItem } from '../types'
import { EstimatesActions, EstimatesType, estimatesTypes, ReleaseEstimateRequest } from './types'

const actions = {
  fetchEstimates: (
    payload: {
      page?: number,
      size?: number,
      searchParams?: Partial<SearchParams>,
    },
    callback?: (succ: boolean) => void): EstimatesActions => ({
      type: estimatesTypes.FETCH_ESTIMATES,
      payload,
      callback
    }),
  fetchRelatedEstimates: (payload: string, callback?: (succ: boolean) => void): EstimatesActions => ({
    type: estimatesTypes.FETCH_RELATED_ESTIMATES,
    payload,
    callback
  }),
  updateEstimate: (payload: Partial<EstimateItem>, callback?: (succ: boolean) => void): EstimatesActions => ({
    type: estimatesTypes.UPDATE_ESTIMATE,
    payload,
    callback
  }),
  setEstimates: (payload: EstimatesType): EstimatesActions => ({
    type: estimatesTypes.SET_ESTIMATES,
    payload
  }),
  setRelatedEstimates: (payload: EstimateItem[]): EstimatesActions => ({
    type: estimatesTypes.SET_RELATED_ESTIMATES,
    payload
  }),
  fetchEstimatesCounts: (
    payload: {
      page?: number,
      size?: number,
      searchParams?: Partial<SearchParams>,
    },
    callback?: (succ: boolean) => void): EstimatesActions => ({
      type: estimatesTypes.FETCH_ESTIMATE_COUNTS,
      payload,
      callback
    }),
  setEstimatesCounts: (payload: EstimatesType): EstimatesActions => ({
    type: estimatesTypes.SET_ESTIMATES_COUNTS,
    payload
  }),

  releaseEstimate: (payload: {
    estimateId: string,
    releaseEstimateRequest: ReleaseEstimateRequest
  }, callback?: (succ: boolean) => void): EstimatesActions => ({
    type: estimatesTypes.RELEASE_ESTIMATE,
    payload,
    callback
  }),
  releaseHomeplanEstimate: (
    payload: string,
    callback?: (succ: boolean) => void
  ): EstimatesActions => ({
    type: estimatesTypes.RELEASE_HOMEPLAN_ESTIMATE,
    payload,
    callback
  }),
  downloadCSV: (
    payload: {
      searchParams?: Partial<SearchParams>
    }, callback: (succ: boolean, csvUrl?: string) => void): EstimatesActions => ({
      type: estimatesTypes.DOWNLOAD_ESTIMATE_CSV,
      payload,
      callback,
    }),

  getCSV: (
    payload: string,
    callback: (succ: boolean, csvUrl?: string) => void): EstimatesActions => ({
      type: estimatesTypes.GET_ESTIMATES_CSV,
      payload,
      callback,
    }),
  setCSVEstimates: (payload: string): EstimatesActions => ({
    type: estimatesTypes.SET_ESTIMATES_CSV,
    payload
  }),
  assignMultipleEstimates: (payload: {
    estimateIds: string[],
    estimatorId: string
  }, callback: (succ: boolean) => void): EstimatesActions => ({
    type: estimatesTypes.ASSIGN_MULTIPLE_ESTIMATES,
    payload,
    callback
  })
}

export default actions
